const formatBytes = (value) => {
  /* eslint-disable no-undef */
  const bigIntValue = BigInt(Number.isInteger(Number(value)) ? value : 0);
  const GB = BigInt(1024 * 1024 * 1024);
  const MB = BigInt(1024 * 1024);
  /* eslint-disable no-undef */

  if (bigIntValue >= GB) {
    const gbWhole = bigIntValue / GB;
    const gbRemainder = bigIntValue % GB;

    const decimal = (gbRemainder * 10n) / GB;
    return `${gbWhole}.${decimal} GB`;
  }

  if (bigIntValue >= MB) {
    const mbWhole = bigIntValue / MB;
    const mbRemainder = bigIntValue % MB;
    const decimal = (mbRemainder * 10n) / MB;
    return `${mbWhole}.${decimal} MB`;
  }

  return `${bigIntValue} B`;
};

export default formatBytes;
